import { render, staticRenderFns } from "./OrderDetailsItemView.vue?vue&type=template&id=65072596&"
import script from "./OrderDetailsItemView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsItemView.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65072596')) {
      api.createRecord('65072596', component.options)
    } else {
      api.reload('65072596', component.options)
    }
    module.hot.accept("./OrderDetailsItemView.vue?vue&type=template&id=65072596&", function () {
      api.rerender('65072596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/OrderDetailsItemView.vue"
export default component.exports